/**
 * Decide whether to surface the one-time "we detected your timezone" prompt.
 *
 * Pure + deterministic so the rule is unit-tested without DOM/toasts. The
 * prompt fires only when the user has no saved zone, the browser detected a
 * usable non-UTC zone, and they have not dismissed the prompt before — and we
 * never write silently: a positive result only means "offer the CTA".
 */
export function shouldSuggestTimezone(opts: {
	saved: string | null | undefined;
	detected: string;
	detectedIsValid: boolean;
	dismissed: boolean;
}): boolean {
	const { saved, detected, detectedIsValid, dismissed } = opts;
	if (saved) return false; // already chosen
	if (dismissed) return false; // asked once already
	if (!detected || detected === 'UTC' || !detectedIsValid) return false;
	return true;
}
